import { render, staticRenderFns } from "./SupplierCompaniesIndex.vue?vue&type=template&id=5a6cf3df"
import script from "./SupplierCompaniesIndex.vue?vue&type=script&lang=js"
export * from "./SupplierCompaniesIndex.vue?vue&type=script&lang=js"
import style0 from "./SupplierCompaniesIndex.vue?vue&type=style&index=0&id=5a6cf3df&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports